import React, { Component } from "react";
import styles from "../../assets/css/modules/shared/switch-slider.css";

/*
Switch Slider Component
Note: id is required for SwitchSlider component to function. Name, currentValue, defaultChecked and onChange are optional.
Usage: <SwitchSlider id="id" onChange={function (e) { console.log("Checkbox Current State: " + e.target.checked); }} />
*/

export default class SwitchSlider extends Component {
  render() {
    return (
      <div className={styles.switchSlider}>
        <input
          type="checkbox"
          name={this.props.Name}
          className={styles.switchSliderCheckbox}
          id={this.props.id}
          checked={this.props.currentValue}
          defaultChecked={this.props.defaultChecked}
          onChange={this.props.onChange}
          disabled={this.props.disabled}
        />
        {this.props.id ? (
          <label className={styles.switchSliderLabel} htmlFor={this.props.id}>
            <span
              className={
                this.props.disabled
                  ? styles.switchSliderInner + " " + styles.switchSliderDisabled
                  : styles.switchSliderInner
              }
            />
            <span
              className={
                this.props.disabled
                  ? styles.switchSliderSwitch +
                    " " +
                    styles.switchSliderDisabled
                  : styles.switchSliderSwitch
              }
            />
          </label>
        ) : null}
      </div>
    );
  }
}
